import { useTranslation } from 'react-i18next'
import { ImagePlaceholder } from '../ImagePlaceholder/ImagePlaceholder'
import { cx } from '../utils/cx'
import type { StayHeaderProps } from './types'
import './StayHeader.css'

/** Tarjeta de estado de la estancia (DESIGN.md §4): foto a sangre, degradado inferior, nombre h2, fechas y cuenta atrás en display. */
export function StayHeader({ propertyName, subtitle, countdown, countdownLabel, image, imageLabel, logo, headingLevel = 1, className }: StayHeaderProps) {
  const { t } = useTranslation()
  const Heading = headingLevel === 1 ? 'h1' : 'h2'
  return (
    <header className={cx('hp-stay', className)}>
      <div className="hp-stay__media">
        {typeof image === 'string' ? (
          <img src={image} alt="" className="hp-stay__img" />
        ) : (
          (image ?? <ImagePlaceholder label={imageLabel ?? t('v2.ds.stayHeader.fotoPortada')} ratio="auto" icon={null} className="hp-stay__placeholder" />)
        )}
      </div>
      <div className="hp-stay__scrim" aria-hidden="true" />
      {logo && <div className="hp-stay__logo">{logo}</div>}
      <div className="hp-stay__content">
        <Heading className="hp-stay__name">{propertyName}</Heading>
        {subtitle && <div className="hp-stay__subtitle tnum">{subtitle}</div>}
        {countdown && (
          <div className="hp-stay__countdown">
            <span className="hp-stay__countdown-value tnum">{countdown}</span>
            {countdownLabel && <span className="hp-stay__countdown-label">{countdownLabel}</span>}
          </div>
        )}
      </div>
    </header>
  )
}
